/**
 * Бейдж «ШІ» — позначка сторінок і функцій, де працює агент Oblik+/AI
 * (рішення власника 2026-10-02): надрядковий, синій фон. Кольори — токени теми
 * (`--ai-badge-bg/fg`, Закон дизайну #11).
 */
export default function AiBadge({ title }: { title?: string }) {
  return (
    <sup className="ai-badge" title={title ?? 'Працює зі штучним інтелектом Oblik+/AI'}>ШІ</sup>
  );
}
